import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57ea7be1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "live" }
const _hoisted_2 = {
  key: 0,
  class: "live-wrapper"
}

import {CourseLiveVO, fetchLiveContent} from "@/apis/live";
import {onBeforeMount, ref} from "vue";
import {CoursePlanPartVO} from "@/apis/course";
import MainLiveFileList from './MainLiveFileList'
import MainLiveHeader from './MainLiveHeader'
import MainLiveContent from './MainLiveContent'


// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'MainLive',
  props: {
    part: {}
  },
  setup(__props: any) {

const props = __props
const courseLiveVO = ref<CourseLiveVO>();

const getLiveContent = async (courseId:number, partId:number) => {
  let data = await fetchLiveContent(courseId, partId);
  courseLiveVO.value = data?.data
}

onBeforeMount(() => {
  getLiveContent(props.part.userCoursePlanPart.courseId, props.part.id)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (courseLiveVO.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(MainLiveHeader), {
            part: _ctx.part,
            live: courseLiveVO.value?.live
          }, null, 8, ["part", "live"]),
          _createVNode(_unref(MainLiveContent), {
            live: courseLiveVO.value?.live,
            pages: courseLiveVO.value?.recordedPages || [],
            courseId: _ctx.part.userCoursePlanPart.courseId,
            partId: _ctx.part.id
          }, null, 8, ["live", "pages", "courseId", "partId"]),
          (courseLiveVO.value?.previewMaterialsPages?.length > 0)
            ? (_openBlock(), _createBlock(_unref(MainLiveFileList), {
                key: 0,
                title: "预习资料",
                pages: courseLiveVO.value?.previewMaterialsPages
              }, null, 8, ["pages"]))
            : _createCommentVNode("", true),
          (courseLiveVO.value?.instructorCoursewarePages?.length > 0)
            ? (_openBlock(), _createBlock(_unref(MainLiveFileList), {
                key: 1,
                title: "讲师课件",
                pages: courseLiveVO.value?.instructorCoursewarePages
              }, null, 8, ["pages"]))
            : _createCommentVNode("", true),
          (courseLiveVO.value?.extendedReadingPages?.length > 0)
            ? (_openBlock(), _createBlock(_unref(MainLiveFileList), {
                key: 2,
                title: "拓展阅读",
                pages: courseLiveVO.value?.extendedReadingPages
              }, null, 8, ["pages"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})